export default "__VITE_ASSET__BUdX8Szo__"